import clsx from "clsx";
import React from "react";

interface InfoBadgeProps {
  icon?: React.ReactNode;
  text: string | React.ReactNode;
  bgColor?: string;
  borderColor?: string;
  borderWidth?: string;
  textColor?: string;
  width?: string;
  height?: string;
}

const InfoBadge: React.FC<InfoBadgeProps> = ({
  icon,
  text,
  bgColor = "bg-tertiaryGreen-50",
  borderColor = "border-tertiaryGreen-700",
  borderWidth = "border",
  textColor = "text-primaryGray-2",
  width = "w-72",
  height = "h-8",
}) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center gap-1.5 rounded-3xl px-1.5 py-0.5",
        width,
        height,
        borderWidth,
        borderColor,
        bgColor,
      )}
    >
      {icon}
      <span className={clsx("text-tiny font-semiBold leading-tiny", textColor)}>
        {text}
      </span>
    </div>
  );
};

export default InfoBadge;
